// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import EventList from "./pages/EventList";
import EventUploader from "./components/EventUploader";
import Login from './pages/Login';
import { AuthProvider, useAuth } from './AuthProvider';
import UploadMedia from "./components/UploadMedia";
import Gallery from "./pages/Gallery";
import Store from "./pages/Store";
import BellaBizarreDashboard from "./pages/BellaBizarrePortfolioStoreDashboard";
import BellaBizarreNav from "./components/BellaBizarreNav";
import Footer from "./components/footer";

// ProtectedRoute component that redirects to /login if the user is not authenticated
const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  return children;
};




function App() {
  return (
      <AuthProvider>
        <Router>
          <BellaBizarreNav />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/EventList" element={<EventList />} />
            <Route path="/login" element={<Login />} />
            <Route path="/Gallery" element={<Gallery/>}/>
            <Route path="/store" element={<Store />} />
            <Route
                path="/CreateEvent"
                element={
                  <ProtectedRoute>
                    <EventUploader />

                  </ProtectedRoute>
                }
            />

            <Route
                path="/BellaBizarreDashboard"
                element={
                  <ProtectedRoute>
                    <BellaBizarreDashboard/>
                  </ProtectedRoute>
                }
            />

            <Route
                path="/UploadMedia"
                element={
                  <ProtectedRoute>
                    <UploadMedia />

                  </ProtectedRoute>
                }
            />
          </Routes>
          <Footer/>
        </Router>
      </AuthProvider>
  );
}

export default App;
